import React, { useEffect, useState, useCallback } from "react";
import API from "./axiosInstance";

function ProductReviews({ productId, reload }) {
  const [reviews, setReviews] = useState([]);

  const fetchReviews = useCallback(async () => {
    const res = await API.get(`/reviews/${productId}`);
    setReviews(res.data);
  }, [productId]);

  useEffect(() => {
    fetchReviews();
  }, [fetchReviews, reload]);  // now perfect

  return (
    <div>
      <h3>Reviews</h3>
      {reviews.length === 0 ? (
        <p>No reviews yet.</p>
      ) : (
        reviews.map((r) => (
          <div key={r.id}>
            <p>Rating: {"⭐".repeat(r.rating)}</p>
            <p>{r.comment}</p>
          </div>
        ))
      )}
    </div>
  );
}

export default ProductReviews;
